// components styles
import { EntitySearchListItem } from '../../EntitySearch.styles';
import {
  EntityOptionColumn,
  EntityOptionRow
} from '../EntitySearchInput/EntitySearchInput.styles';

// types
import type {
  EntitySearchOption,
  UseEntityOptionColumnsReturnType
} from '../../EntitySearch.types';

type Column = UseEntityOptionColumnsReturnType[number];

type EntitySearchOptionItemProps = {
  props: React.HTMLAttributes<HTMLLIElement>;
  option: EntitySearchOption;
  columns: UseEntityOptionColumnsReturnType;
  isDebouncing: boolean;
};

function resolveColumnValue(col: Column, option: EntitySearchOption): unknown {
  const rawValue = option[col.key as keyof EntitySearchOption];
  if (col.valueFormatter) {
    return col.valueFormatter(rawValue as string | Date | undefined);
  }
  if (col.key === 'number' && !rawValue) {
    return option.number ?? option.entity?.number;
  }
  return rawValue;
}

export function EntitySearchOptionItem({
  props,
  option,
  columns,
  isDebouncing
}: EntitySearchOptionItemProps) {
  const visibleColumns = columns.filter((col) => !col.hidden);
  const columnWidths = visibleColumns.map((col) => col.width);

  return (
    <EntitySearchListItem {...props} disabled={isDebouncing}>
      <EntityOptionRow columnWidths={columnWidths}>
        {visibleColumns.map((col) => (
          <EntityOptionColumn key={col.key}>
            {(resolveColumnValue(col, option) as React.ReactNode) ||
              (option[col.key as keyof EntitySearchOption] as React.ReactNode)}
          </EntityOptionColumn>
        ))}
      </EntityOptionRow>
    </EntitySearchListItem>
  );
}
